export * as ricosDocuments from '@wix/auto_sdk_rich-content_ricos-documents/schemas';
export * as ricosEmbeddables from '@wix/auto_sdk_rich-content_ricos-embeddables/schemas';
export * as ricosConversations from '@wix/auto_sdk_rich-content_ricos-conversations/schemas';
